import React from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./Auth.scss";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import Login from "./Login/Login";
import ForgotPassword from "./ForgotPassword/ForgotPassword";
import ErrorPage from "./ErrorPage/ErrorPage";

const Auth = () => {
  const { i18n } = useTranslation();
  const username = sessionStorage.getItem("username");
  const sessionId = sessionStorage.getItem("s_id");
  const authenticate = (page, allowWhenAuthenticated = false) => {
    if (username && sessionId && !allowWhenAuthenticated) {
      return <Navigate to="/" replace />;
    } else return page;
  };

  const translate = () => {
    if (!localStorage.getItem("i18nextLng")) {
      localStorage.setItem("i18nextLng", "ar");
      i18n.changeLanguage("ar");
    } else if (localStorage.getItem("i18nextLng") === "en") {
      localStorage.setItem("i18nextLng", "ar");
      i18n.changeLanguage("ar");
    } else {
      localStorage.setItem("i18nextLng", "en");
      i18n.changeLanguage("en");
    }
  };

  return (
    <div
      className={classnames(`auth-page`, { rightCtl: i18n.language === "ar" })}
    >
      <div className="translate" onClick={translate}>
        {!localStorage.getItem("i18nextLng")
          ? "عربي"
          : localStorage.getItem("i18nextLng") === "en"
          ? "عربي"
          : "English"}
      </div>
      <div className="bg" />
      <div className="right">
        {" "}
        <Routes>
          <Route exact path="/" element={authenticate(<ErrorPage />)} />
          <Route path="/login" element={authenticate(<Login />)} exact />
          <Route
            path="/forgot-password"
            element={authenticate(<ForgotPassword />, true)}
            exact
          />{" "}
        </Routes>
      </div>
    </div>
  );
};

export default Auth;
